'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return [{
    title: '首 页',
    lan: 'index',
    home: 'header_zlb',
    router: '/index',
    firstView: 'index'
  }, {
    title: '公开课',
    lan: 'dynamic',
    home: 'look_zlb',
    router: '/dynamicList',
    firstView: 'dynamicList'
  }, {
    title: '公开课',
    lan: 'lecture',
    home: 'look_zlb',
    router: '/course/course-list',
    firstView: 'course'
    // firstView: 'course'
    // list: [{
    //   label: 'look_zlb.dynamic',
    //   name: '/dynamicList',
    //   value: 'dynamic'
    // }, {
    //   label: 'look_zlb.lecture',
    //   name: '/course/course-list',
    //   value: 'lecture'
    // }]
  }, {
    title: '研讨',
    lan: 'discuss',
    home: 'index_zlb',
    router: '/class/class-list',
    firstView: 'class',
    list: [{
      label: 'header_zlb.curDis',
      name: '/class/class-detail',
      value: 'current'
    }, {
      label: 'header_zlb.hisDis',
      name: '/class/class-list',
      value: 'history'
    }]
  },
  // {
  //   title: '消息',
  //   lan: 'message',
  //   home: 'header_zlb',
  //   router: '/onLine/onLine-list',
  //   firstView: 'onLine'
  // },
  {
    title: '个人中心',
    lan: 'userCenter',
    home: 'index_zlb',
    router: '/usercenter/mycourse',
    firstView: 'usercenter'
  }];
};